// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3":"2675799f17de1934","84":"4b6a3bb0a617d839","334":"c7e4fc1782cc0386","480":"ed2b508a0f1340fa","711":"d48ddb9050f7b2b3","795":"65ea6086c1a3f6ba"}[chunkId] + ".js";
};